import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact, { type BugsnagErrorBoundary } from '@bugsnag/plugin-react'
import React from 'react'

import ApiError from '~/common/api/exceptions'
import { parseResponse } from '~/common/utils'
import { BUGSNAG_API_KEY, ENVNAME } from '~/constants/environment'

import packageJson from '../../../package.json'

const ErrorBoundary = BUGSNAG_API_KEY
  ? (() => {
      Bugsnag.start({
        apiKey: BUGSNAG_API_KEY,
        appVersion: packageJson.version,
        releaseStage: ENVNAME,
        plugins: [new BugsnagPluginReact()],
        onError: event => {
          if (event.originalError instanceof ApiError) {
            const error = event.originalError
            if (error.request) {
              event.addMetadata('api_request', error.request)
            }

            if (error.response) {
              event.addMetadata('api_response', parseResponse(error))
            }
          }
        },
      })
      return Bugsnag.getPlugin('react')?.createErrorBoundary(React)
    })()
  : undefined

type BugSnagProps = Pick<React.ComponentProps<BugsnagErrorBoundary>, 'FallbackComponent'>

function BugSnag(props: React.PropsWithChildren<BugSnagProps>) {
  if (ENVNAME !== 'local') {
    if (!ErrorBoundary) {
      console.error('[ccn-widget] Failed to load error reporting module')
    } else {
      return <ErrorBoundary {...props} />
    }
  }

  return <>{props.children}</>
}

export default BugSnag
